import React from 'react'
import FormatNumberFuncs from '../../../../../../Classes/numberFormatFunctions'
import meta from './images/linkedin/linkedin_meta.svg'
import actions from './images/linkedin/linkedin_actions.svg'
import input from './images/linkedin/linkedin_input.svg'
import videoOverlay from './images/linkedin/linkedin_video_overlay.svg'
import { LinkPreview } from '../shared'

export default function SocialLinkedinPreview({ account, content, images = [], foundLink = null, video = false }) {
    return (
        <div style={{ width: 480, borderRadius: '8px', fontFamily: 'inter', backgroundColor: 'white' }}>
            {/* header */}
            <div style={{ padding: '12px 16px', display: 'flex', alignItems: 'center' }}>
                <img src={account.image} style={{ marginRight: 8, height: 48, width: 48 }} />
                <div style={{ display: 'block' }}>
                    <div style={{ color: '#191919', fontSize: '14px', fontWeight: 600, lineHeight: '20px' }}>
                        {account.name}
                    </div>
                    <div style={{ color: '#666666', fontSize: '12px', fontWeight: 400, lineHeight: '16px' }}>
                        {FormatNumberFuncs.formatNumber(account.followers)} followers
                    </div>
                    <img src={meta} />
                </div>
            </div>

            {/* content */}
            <div
                style={{
                    padding: '0 16px 8px 16px',
                    color: '#191919',
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    overflow: 'hidden',
                    wordWrap: 'break-word',
                    textOverflow: '... more',
                    wordBreak: 'break-all'
                }}
                dangerouslySetInnerHTML={{ __html: content }}
            ></div>

            {/* link preview */}
            {!!foundLink && !images.length && (
                <div style={{ padding: '0 16px 16px 16px' }}>
                    <LinkPreview title={foundLink.title} image={foundLink.image} />
                </div>
            )}

            {/* image */}
            {images.length === 1 && (
                <div style={{ position: 'relative' }}>
                    <img
                        src={images[0].url || images[0]}
                        style={{
                            backgroundColor: '#e0e0e0',
                            width: '100%',
                            position: 'relative',
                            justifyContent: 'center'
                        }}
                    />
                    {video && (
                        <div
                            style={{
                                position: 'absolute',
                                height: '100%',
                                width: '100%',
                                top: 0,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'flex-end'
                            }}
                        >
                            <img src={videoOverlay} />
                            {/* <Icons icon="play" style={{ height: 30, width: 30 }} color="rgba(255,255,255, 0.6)" /> */}
                        </div>
                    )}
                </div>
            )}

            {images.length > 1 && (
                <div
                    style={{
                        display: 'flex',
                        padding: '0 0 16px 0',
                        position: 'relative',
                        height: 320,
                        width: 480,
                        gap: 2
                    }}
                >
                    {/* split the images, 1st on the left, rest on the right stacked, up to 3 then a plus indicating more */}
                    <div style={{ flexGrow: 1 }}>
                        <div
                            key={0}
                            style={{
                                backgroundSize: 'cover',
                                backgroundPositionX: 'center',
                                backgroundPositionY: 'center',
                                backgroundRepeat: 'no-repeat',
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                backgroundImage: `url(${images[0].url || images[0]})`
                            }}
                        ></div>
                    </div>
                    <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {images.slice(1).map((image, index) => {
                            if (index > 2) return null
                            return (
                                <div
                                    key={index}
                                    style={{
                                        position: 'relative',
                                        backgroundSize: 'cover',
                                        backgroundPositionX: 'center',
                                        backgroundPositionY: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        backgroundImage: `url(${image.url || image})`
                                    }}
                                >
                                    {index === 2 && images.length > 4 && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                height: '100%',
                                                width: '100%',
                                                top: 0,
                                                backgroundColor: 'rgba(0,0,0,0.5)',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                color: 'white',
                                                fontSize: 32,
                                                fontWeight: '600'
                                            }}
                                        >
                                            +{images.length - 4}
                                        </div>
                                    )}
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}

            {/* share */}
            <div style={{ padding: '0 16px' }}>
                <img src={actions} />
                <div style={{ display: 'flex', padding: '0 0 8px 0' }}>
                    <img style={{ marginRight: 6, height: 40, width: 40, borderRadius: '50%' }} src={account.image} />
                    <img src={input} />
                </div>
            </div>
        </div>
    )
}
